import React from "react";
import { ImageOqt, SimpleSelectOqt, SwitchOqt, TextOqt, WrapperComponent } from "../..";

const tiposOperaciones = [
  {label: "Operación UI", value: "UIOperation"},
  {label: "Operación Batch", value: "BatchOperation"},
  {label: "Operación", value: "Operation"},
]

export const FormEditProps = ({fmk}) => {
  return (
    <>
      <WrapperComponent caption="Tipo de operación" Field={<SimpleSelectOqt name="tipoOperacion" formik={fmk} variant="standard" optionsList={tiposOperaciones}/>}/>
      <WrapperComponent caption="Nombre" Field={<TextOqt name="nombre" formik={fmk} variant="standard"/>}/>
      <WrapperComponent caption="Imagen" Field={<ImageOqt name="imagen" formik={fmk} variant="standard"/>}/>
      <WrapperComponent caption="Orden" Field={<TextOqt name="orden" formik={fmk} variant="standard"/>}/>
      <WrapperComponent caption="Activa" Field={<SwitchOqt name="activa" formik={fmk} variant="standard"/>}/>
    </>
  )
}